import type { Vob } from '@finpay-estimation/estimation-types';

/** V3 VOB API expects `plan.planCode` as string; some payloads use numbers. */
export function withVobPlanCodeAsString(vob: Vob): Vob {
  if (vob?.plan == null || vob.plan.planCode == null) {
    return vob;
  }
  const { planCode } = vob.plan;
  if (typeof planCode === 'string') {
    return vob;
  }
  return {
    ...vob,
    plan: {
      ...vob.plan,
      planCode: String(planCode),
    },
  };
}
